module.exports = __webpack_public_path__ + "static/media/read_content_aloud_ass.cdd35964.mp3";